import Flow from 'components/generics/flows/Flow';
import SignUp from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUp';
import SignUpVerify from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/components/SignUpVerify';
import { SignUpProvider } from 'components/generics/flows/LoginSignUpFlow/SignUpFlow/context';
import LandaTheme from 'components/layouts/LandaTheme';
import { KYC_ROUTE, LOGIN_ROUTE } from 'consts/routes/urls';
import { useLandaRouter } from 'hooks/logics/useLandaRouter';
import React from 'react';
import { THEMEABLE_COMPONENTS } from 'stores/LandaTheme/landaTheme';

type Props = {
  onLogin?: () => void;
  onFinish?: () => void;
  tenant: boolean;
};

const SignUpFLow = ({ onLogin, onFinish, tenant }: Props) => {
  const components = [{ component: SignUp }, { component: SignUpVerify }];
  const { navigate } = useLandaRouter();

  return (
    <LandaTheme id={THEMEABLE_COMPONENTS.SIGN_UP_FLOW}>
      <SignUpProvider>
        <Flow
          components={components}
          onFinish={() => (onFinish ? onFinish() : navigate(KYC_ROUTE))}
          initialProps={{
            onLogin: () => (onLogin ? onLogin() : navigate(LOGIN_ROUTE)),
            tenant,
          }}
        />
      </SignUpProvider>
    </LandaTheme>
  );
};

export default SignUpFLow;
